import { useState } from "react";

export default function useBatchProgress() {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);

    const start = (rows) => {
        const initial = rows.map((r) => ({
            id: r.id,
            label: `${r.requestNumber || ""} ${r.payer || ""}`.trim(),
            status: "pending",
            message: "",
        }));
        setItems(initial);
        setOpen(true);
    };

    const update = (id, patch) => {
        setItems((prev) =>
            prev.map((x) => (x.id === id ? { ...x, ...patch } : x))
        );
    };

    const close = () => setOpen(false);

    return { items, open, start, update, close };
}